import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from './config.service';
import {ManageOrganisationService} from './manage-organisation.service';
import {YourPlaceListing} from '../models/your-place/your-place-listing';
import {YourPlaceListedPostModel} from '../models/your-place/your-place-listed-post-model';
import {YourPlaceLeadPostModel} from '../models/your-place/your-place-lead-post-model';
import {Lead} from '../models/tenant-find/lead';
import {RequestListingPost} from '../models/your-place/request-listing';

@Injectable()
export class YourPlaceService {
    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private manageOrganisationService: ManageOrganisationService) {
    }

    requestListing(model: RequestListingPost) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/your-place/listings`
        return this.http.post<YourPlaceListing>(url, model);
    }

    requestListingRemoval(guid: string) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/your-place/listings/${guid}`
        return this.http.delete<YourPlaceListing>(url);
    }

    requestListingUpdate(guid: string) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/your-place/listings/${guid}/request-update`
        return this.http.post<YourPlaceListing>(url, null);
    }

    getListingLeads(guid: string) {
        const url = `${this.configService.baseUrl}/your-place/listings/${guid}/leads`
        return this.http.get<Lead[]>(url);
    }

    getListings(deleted: boolean, search: string = null) {
        const url = `${this.configService.baseUrl}/your-place/listings`
        let params = new HttpParams().set('deleted', deleted);
        if (search) params = params.append('search', search);
        return this.http.get<YourPlaceListing[]>(url, {params});
    }

    getOrganisationListings(organisationReference: string, propertyReference: string) {
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/your-place/listings`
        const params = new HttpParams().set('propertyReference', propertyReference);
        return this.http.get<YourPlaceListing[]>(url, {params});
    }

    markAsListed(guid: string, model: YourPlaceListedPostModel) {
        const url = `${this.configService.baseUrl}/your-place/listings/${guid}/mark-as-listed`
        return this.http.post<YourPlaceListing>(url, model);
    }

    markAsDeleted(guid: string) {
        const url = `${this.configService.baseUrl}/your-place/listings/${guid}/mark-as-deleted`
        return this.http.post<YourPlaceListing>(url, null);
    }

    markAsUpdated(guid: string) {
        const url = `${this.configService.baseUrl}/your-place/listings/${guid}/mark-as-updated`
        return this.http.post<YourPlaceListing>(url, null);
    }

    addLead(guid: string, model: YourPlaceLeadPostModel) {
        const url = `${this.configService.baseUrl}/your-place/listings/${guid}/add-lead`
        return this.http.post<YourPlaceListing>(url, model);
    }
}
